<template>
    <div class="main-wrapper">
        <BHeader :title="helpTopMsg" :isLogin="true"/>
        <div v-if="infoFlg == 1 && isDispatchAgencyFlagEx == false">
            <BContainer class="input-font" style="padding: 0px 16px; maring-top:16px;">
                    <label>{{$t("help.consult_tel")}}</label>
                    <BButton class="form-submit" style="border:none;margin-top: 8px;">
                        <BImg :src="fix_phone_src" style="margin-right: 4px;"></BImg>
                        <a href="tel:03-5202-7121" style="color: #FFFFFF;font-weight: 600;font-size: 16px;line-height: 21px;text-decoration: none;">03-5202-7121（{{$t("help.connotation")}}）</a>
                    </BButton>
                    <p>{{$t("help.consult_tel_notice")}}</p>
            </BContainer>
        </div>

        <div v-if="infoFlg == 1 && isDispatchAgencyFlagEx == false">
            <BContainer class="set">
                <div class="set-inline" @click="goUsrPro">
                    <div class="inner-inline">
                        <BImg :src="help_src" class="set-img"></BImg>
                        <a href="https://cybaxuniv-support2user.zendesk.com/hc/ja" target="_self" style="color: #30353B;text-decoration: none;" @click="viewFAQ()">{{$t("help.question")}}</a>
                    </div>
                    <BImg :src="arrow_forward_src"></BImg>
                </div>
                <div class="set-inline" @click="goUsrPas" style="margin-top: 9px;">
                    <div class="inner-inline">
                        <BImg :src="question_answer_src" class="set-img"></BImg>
                        <a :href="usrinquire_new_url" target="_blank" style="color: #30353B;text-decoration: none;">{{$t("help.enquiry")}}</a>
                    </div>
                    <BImg :src="arrow_forward_src"></BImg>
                </div>
            </BContainer>
        </div>

        <BContainer class="set">
            <div v-if="infoFlg == 1 && isDispatchAgencyFlagEx == false">
                <label>{{$t("help.service_manual")}}</label>
            </div>
            <div v-else>
                <div class="set-inline" @click="goUsrPro">
                    <div class="inner-inline">
                        <BImg :src="help_src" class="set-img"></BImg>
                        <a href="https://cybaxuniv-support2user.zendesk.com/hc/ja" target="_self" style="color: #30353B;text-decoration: none;" @click="viewFAQ()">{{$t("help.question")}}</a>
                    </div>
                    <BImg :src="arrow_forward_src"></BImg>
                </div>
                <label>{{$t("help.service_manual")}}</label>
            </div>
            <div v-if="infoFlg == 1 || isDispatchAgencyFlagEx == true" class="set-inline" @click="goUsrPro">
                <div class="inner-inline">
                    <BImg :src="phone_src" class="set-img"></BImg>
                    <a @click="toPopEnvironment()" target="_blank" style="color: #30353B;text-decoration: none;">{{$t("help.environment")}}</a>
                </div>
                <BImg :src="arrow_forward_src"></BImg>
            </div>
            <div style="display: flex;flex-direction: column; gap:8px;margin-top:24px;">
                <div v-for="(item,index) in files_dataset" :key="index">
                    <div class="download-button" @click="item.appendFileName.callBack">
                        <div align="left" style="flex:auto;text-decoration: none;">
                            <a>{{item.appendFileName.text}}</a>
                            <BImg :src="picture_as_pdf_src" v-if="item.appendFileName.text.split('.').pop() == 'pdf'"></BImg>
                        </div>
                        <div align="right" style="flex:auto">
                            <BImg :src="cloud_download_src"></BImg>
                        </div>
                    </div>
                </div>
            </div>
        </BContainer>

        <BImg v-if="msgBtnShow" :src="follow_src" style="position: fixed; z-index:1031; right:16px; bottom: 64px;" @click="openWidget()"></BImg>

        <BFooter whichPage="ヘルプ"/>
    </div>
</template>
<script>
import BHeader from '@/views/header.vue'
import BFooter from '@/views/footer.vue'
import UAParser from 'ua-parser-js'
import { ref,onMounted,inject,onBeforeUnmount, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { getToken } from '@/utils/CookieUtils'
import JwtDecode from 'jwt-decode'
import { post } from '@/utils/request'
import { useI18n } from 'vue-i18n'
export default {
    components:{
    BHeader,
    BFooter,
},
    setup(){
        gtag('event', 'viewHelp', {
          'event_name': 'view'
        })
        let isJcc =ref()
        const router = useRouter()
        const service = inject("service")
        const fix_phone_src = require('@/assets/icon/fix_phone.svg')
        const arrow_forward_src = require('@/assets/icon/arrow_forward_ios.svg')
        const help_src = require('@/assets/icon/help.svg')
        const question_answer_src = require('@/assets/icon/question_answer.svg')
        const phone_src = require('@/assets/icon/phone.svg')
        const picture_as_pdf_src =require('@/assets/icon/picture_as_pdf.svg')
        const cloud_download_src = require('@/assets/icon/cloud_download.svg')
        const follow_src = require('@/assets/icon/follow.svg')
        const files_dataset = ref([])
        const msgBtnShow = ref(false)
        const helpTopMsg = ref('')
        const usrinquire_new_url = ref(window.location.pathname == '/help' ? '/usrinquire_new': '/smt/usrinquire_new')
        const exts = document.createElement('script')
        exts.type = 'text/javascript';
        exts.id = 'ze-snippet'
        exts.src = 'https://static.zdassets.com/ekr/snippet.js?key=eaeeb030-513f-4edb-8f24-63b080e7239e';
        const { t } = useI18n({ useScope: 'global' })
        const isDispatchAgencyFlagEx = ref(false)

        function downloadFile(filename, fileurl){
            const ua = new UAParser();
            let userAgent = ua.getUA();
            const downloadData = {filename:'',fileurl:'',userAgent:''}
            downloadData.filename = filename
            downloadData.fileurl = fileurl
            downloadData.userAgent = userAgent
            service.common.downloadFile(downloadData)
        }


        function downloadSystemFile(filename, fileurl){
            var ua = new UAParser();
            let userAgent = ua.getUA();
            const downloadData = {filename:'', fileurl:'', userAgent:''}
            downloadData.filename = filename;
            downloadData.fileurl = fileurl;
            downloadData.userAgent = userAgent;
            service.common.downloadSystemFile(downloadData)
        }

        function toPopEnvironment () {
            router.push({ path: 'popenvironment'})
        }

        document.body.appendChild(exts)
        onBeforeMount(()=>{
            window.zESettings = {
                webWidget:{
                    position: { horizontal: 'right', vertical: 'bottom' },
                    offset: {
                            mobile: {
                                horizontal: '20px',
                                vertical: '0px',
                            }
                        },
                    }
            }
        })

        const timer = ref()
        const infoFlg = ref(0)
        onMounted(async ()=>{
            const jwtToken = getToken()
            const decodedToken = JwtDecode(jwtToken)
            if (typeof decodedToken !== 'InvalidTokenError') {
                await post('/api/user/getCipherInfo').then(async res => {
                    isJcc=res.data.isDispatchAgencyFlag
                    var manualdivDto = '4';
                    if (isJcc == true) {
                        manualdivDto = '7';
                    }
                    await service.popmul.index({manualdiv: manualdivDto}).then(res => {
                        if(res.models) {
                            res.models.forEach(item => {
                                files_dataset.value.push({
                                    manualNm: item.manualNm,
                                    appendFileName: {
                                        text: item.appendFileName,
                                        callBack: function(e) {
                                            downloadFile(item.appendFileName, item.reportFileDir)
                                        },
                                        openPdf: function(e){
                                            openPdf(item.appendFileName, item.reportFileDir)
                                        }
                                    }
                                })
                            });
                        }
                    })
                    infoFlg.value = res.data.InfoFlg
                    if (res.data.isDispatchAgencyFlag == true) {
                        helpTopMsg.value = t('common.jccHelp')
                    } else {
                        helpTopMsg.value = t('common.help')
                    }
                    if(res.data.isDispatchAgencyFlag == false && res.data.InfoFlg == 1 && document.querySelector('#ze-snippet')){
                        msgBtnShow.value = true
                        var close = false;
                        function closeMsg(){
                            if(close){
                                clearInterval(interval)
                            }
                            if(document.querySelector('#launcher') != null && document.querySelector('#launcher').style.visibility != 'hidden')
                            {
                                zE('webWidget', 'hide')
                                zE('webWidget:on',
                                    'close',
                                    function(){
                                        zE('webWidget', 'hide')
                                })
                                document.querySelector('#launcher').style.visibility = 'hidden'
                                close = true;
                            }
                        }
                        var interval = setInterval(closeMsg, 200);
                    }
                    isDispatchAgencyFlagEx.value = res.data.isDispatchAgencyFlag
                    timer.value = window.setInterval(()=>{
                        if(document.querySelector('#launcher')){
                            document.querySelector('#launcher').style.visibility = 'hidden'
                        }
                    })
                })
            }
        })

        function openWidget(){
            window.clearInterval(timer.value)
            zE('webWidget', 'show');
            zE('webWidget', 'open');
            timer.value = window.setInterval(()=>{
                if(document.querySelector('#launcher')){
                    document.querySelector('#launcher').style.visibility = 'hidden'
                }
            })
        }
        function openPdf(filename,fileurl){
            const ua = new UAParser()
            let userAgent = ua.getUA()
            const downloadData = {filename:'',fileurl:'',userAgent:''}
            downloadData.filename = filename
            downloadData.fileurl = fileurl
            downloadData.userAgent = userAgent
            service.common.openFile(downloadData).then((res)=>{
                const reader = res.stream().getReader()
                const binaryData = []
                reader.read().then(function open(response){
                    if(response.done){
                        binaryData.push(response.value)
                        window.open(window.URL.createObjectURL(new Blob(binaryData, {type: 'application/pdf'})))
                    }else{
                        binaryData.push(response.value)
                        reader.read().then(open)
                    }
                }).catch(e=>{
                    console.log(e)
                })
            })
        }
        onBeforeUnmount(()=>{
            window.clearInterval(timer.value)
            if(document.body.querySelector("#ze-snippet")){
                try{
                    zE('webWidget', 'hide');
                    zE('webWidget', 'close');
                    let exts = document.querySelector('#ze-snippet')
                    document.body.removeChild(exts)
                }catch{
                    console.log("")
                }
            }
        })

        function viewFAQ(){
            gtag('event', 'viewFAQ', {
                'event_name': 'view'
            })
        }

        return{
            downloadSystemFile,
            infoFlg,
            usrinquire_new_url,
            files_dataset,
            phone_src,
            arrow_forward_src,
            help_src,
            question_answer_src,
            fix_phone_src,
            picture_as_pdf_src,
            cloud_download_src,
            follow_src,
            msgBtnShow,
            helpTopMsg,
            isDispatchAgencyFlagEx,
            openWidget,
            toPopEnvironment,
            openPdf,
            viewFAQ
        }
    }
}
</script>
<style lang="scss" scoped>
    .main-wrapper{
        margin: 48px 0px;
    }
    label{
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
        color: #8B949E;
    }
    p{
        margin-top: 8px;
        margin-bottom: 32px;
        text-align: center;
        font-weight: 300;
        font-size: 13px;
        line-height: 18px;
        color: #8B949E;
    }
    .set{
        padding: 16px;
        text-align: left;
        .set-text{
            margin-top: 32px;
            margin-bottom: 8px;
            height: 18px;
            font-family: 'Hiragino Kaku Gothic ProN';
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 18px;
            display: flex;
            align-items: center;
            color: #8B949E;
            flex: none;
            order: 0;
            flex-grow: 0;
        }
        .set-inline{
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 56px;
            .inner-inline{
                display: flex;
            }
        }
        .set-img{
            margin-right: 8px;
            width: 24px;
            height: 24px;
        }
        .download-button{
            text-align: left;
            flex:1;
            background-color: rgba(255, 255, 255, 1);
            font-weight: 600;
            font-size: 13px;
            line-height: 18px;
            color:  #066CE5;
            border: 1px solid #2394F7;
            border-radius: 4px;
            padding: 16px;
            display: flex;
            box-shadow: none;
        }
    }
</style>
